import { macroCondition, isTesting } from '@embroider/macros';
import { registerDestructor } from '@ember/destroyable';
import { task, timeout } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';
import Feed from './feed';
export default class FallbackFeed extends Feed {
  kind = 'fallback'

  @tracked infoObject;

  constructor(infoObject, options = {}) {
    super(infoObject, options);
    this.infoObject = infoObject;
    this.startTask.perform();
    registerDestructor(this, this.teardown.bind(this));
  }

  get isLive() {
    return true; // broadcast feed = live feed
  }

  get imageUrl() {
    return this.imageSource?.medium_square?.url
  }

  get url() {
    return this.infoObject?.url;
  }

  get canPlay() {
    return !!this.url
  }

  startTask = task(async () => {
    if (this.settings.debug) {
      console.log(`built fallback feed with options ${this.infoObject}, starting monitors`);
    }

    try {
      await this.updateAttributesTask.perform(this.infoObject) // initial load
    } catch (e) {
      console.error(e)
      //no op
    }
    this.loopTask.perform();
    next(() => this.isLoaded = true)
  });

  loopTask = task(async () => { 
    if (macroCondition(isTesting())) {
      return;
    }
    while (true) {
      try {
        if (this.isLoaded) {
          await timeout(10000);

        } else {
          await timeout(1000);
        }
      } catch (e) {
        //no op
        await timeout(10000);
      }
    }
  });

  playTask = task({ restartable: true, maxConcurrency: 1 }, async () => {
    let sound;
    if (!this.loadedSound) {
      try {
        var results = await this.stereo.playTask.linked().perform((this.url), {
          useConnections: ['NativeAudio', 'Howler'],
          metadata: { },
          xhr: {
            headers: this.session?.authenticatedHeaders,
          },
        });
      } catch (e) {
        throw new Error('failed to load sound', e);
      }
      sound = results?.sound;
    }

    if (this.loadedSound) {
      if (!this.loadedSound.isPlaying && this.loadedSound) {
        await this.loadedSound.togglePause();
      } else {
        // TODO: figure out better queuing
      }
    }

    await timeout(200);
  });

  updateAttributesTask = task(async (nowPlaying) => {
    // this.station = this.currentNowPlayingModel(nowPlaying, 'station')
    // this.broadcast = this.currentNowPlayingModel(nowPlaying, 'broadcast')
    // this.airing = this.currentNowPlayingModel(nowPlaying, 'airing')
    // this.show = this.currentNowPlayingModel(nowPlaying, 'show')
    // this.stream = this.currentNowPlayingModel(nowPlaying, 'stream')
    // this.track = this.currentNowPlayingModel(nowPlaying, 'track')
    // this.traffic = this.currentNowPlayingModel(nowPlaying, 'traffic')
    // this.note = this.currentNowPlayingModel(nowPlaying, 'note')

    // let item = _.maxBy(_.compact([this.track, this.traffic, this.note]), (item) => new Date(item.playedAt).getTime())
    // this.item = item;
    // this.itemType = item?.type;

    // try {
    //   this.feeds.updateAudioMetadata.perform(this.url, {
    //     station: this.station,
    //     broadcast:this.broadcast,
    //     airing: this.airing,
    //     show: this.show,
    //     stream: this.stream,
    //     track: this.track,
    //     note: this.note,
    //     traffic: this.traffic,
    //     imageSource: this.imageSource,
    //   })
    // } catch(e) {
    //   console.error(`error updating audio metadata`, e)
    // }
  });

  teardown() {
    this.cableConnection?.unsubscribe()

    console.log('destroyed broadcast feed', this.url)
  }
}
